var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpert2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "105mm",
    height: "74mm",
    viewBox: "0 0 105 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M861.936 2249.221h-278.89v102.25h278.89v-102.25",
    style: {
      fill: "#100602",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.141 2331.936c-32.203 9.365-64.039-17.834-71.067-60.739l-53.191-315.635 121.344-10.502 48.441 292.188c7.051 42.958-13.375 85.322-45.527 94.688",
    style: {
      fill: "#250f08",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.14934
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.695 2259.186c-.875 44.418-28.304 79.534-61.207 78.41-32.925-1.175-58.957-38.202-58.109-82.634l6.301-301.333 121.054-6.189-8.039 311.746",
    style: {
      fill: "#250f08",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.15616
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.043 1954.59c-4.703 11.82-98.891 17.69-119.488 3.44-6.559-4.5-10.2-34.32-10.2-34.32h135.684s-2.285 21.54-5.996 30.88",
    style: {
      fill: "#5d524e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.039 1907.97H744.355v15.74h135.684v-15.74",
    style: {
      fill: "#2f2927",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.559 1954.59c4.703 11.82 98.961 17.69 119.504 3.44 6.531-4.5 10.292-34.32 10.292-34.32H521.637s2.234 21.54 5.922 30.88",
    style: {
      fill: "#5d524e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.637 1907.97h135.718v15.74H521.637v-15.74",
    style: {
      fill: "#2f2927",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m511.617 2482.3-18.449-54.58 74.348-96.06 20.738 14.57-76.637 136.07",
    style: {
      fill: "#d19771",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m693.732 2674.51 60.287-1.283-.171 77.812-57.212 10.177",
    style: {
      fill: "#f6c4a0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.08599
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.455 2684.75s-117.846-26.88-139.685-59.23c-23.317-34.57-85.282-124.31-89.774-161.38-2.23-18.87 41.281-79.41 83.734-132.48l31.524 34.79-45.461 101.94s66.305 87.95 79.449 107.41l92.285 44.43 110.8 30.33",
    style: {
      fill: "#e9e9e9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724.616 3006.09c-86.481-2.031-154.974-73.712-152.996-160.152 0 0 77.475 18.38 156.257 20.195 92.69 2.105 156.93-13.019 156.93-13.019-1.998 86.483-73.742 154.959-160.191 152.975",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.136 2855.485c1.348-8.373-4.127-16.412-12.299-17.834-8.21-1.378-16.12 3.95-17.813 12.36-1.66 8.336 3.802 16.609 12.324 18.023 8.457 1.512 16.395-4.081 17.788-12.55m30.29 4.399c1.096-8.466-4.685-16.05-12.89-17.368-8.167-1.242-15.985 4.59-17.4 12.97-1.38 8.406 4.41 16.27 12.846 17.584 8.589 1.357 16.37-4.752 17.444-13.186",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.845 2863.251c.784-8.513-5.286-15.875-13.52-16.847-8.179-1.01-15.752 5.027-16.899 13.479-1.12 8.439 4.917 16.156 13.468 17.195 8.542 1.02 16.228-5.38 16.951-13.827",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.364 2865.422c.374-8.59-5.976-15.7-14.182-16.233-8.189-.706-15.504 5.564-16.337 14.062-.814 8.476 5.504 16.023 14.1 16.745 8.67.564 16.085-6.08 16.419-14.574",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.944 2866.168c0-8.57-6.7-15.43-14.979-15.463-8.201-.383-15.149 6.16-15.601 14.717-.43 8.505 6.237 15.732 14.931 16.122 8.653.053 15.643-6.866 15.65-15.376",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M773.533 2865.676c-.334-8.564-7.296-15.045-15.537-14.92-8.229-.01-14.96 6.853-15.052 15.412-.075 8.517 6.886 15.4 15.541 15.433 8.667-.08 15.366-7.47 15.048-15.925",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.086 2864.03c-.705-8.543-7.897-14.798-16.108-14.325-8.197.25-14.703 7.46-14.445 15.97.302 8.558 7.494 15.175 16.132 14.837 8.637-.429 15.074-8.032 14.421-16.481",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M834.53 2861.11c-1.009-8.46-8.474-14.575-16.678-13.67-8.15.747-14.353 8.075-13.766 16.59.606 8.455 8.137 14.894 16.775 14.124 8.575-.925 14.733-8.539 13.67-17.044",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.856 2856.865c-1.493-8.348-9.155-14.07-17.29-12.961-8.11 1.226-13.988 8.77-13.035 17.206.987 8.493 8.75 14.687 17.354 13.367 8.595-1.178 14.402-9.187 12.971-17.612m10.271 46.607c3.967 1.483 8.202 1.228 11.93-.602 3.409-1.907 6.226-5.369 7.451-9.785 1.348-4.33.334-8.777-1.904-12.196-2.23-3.37-5.774-5.704-9.975-6.328-4.162-.667-8.313.323-11.482 2.274-3.124 1.997-5.357 4.903-6.513 8.467-1.03 3.571-.273 7.302 1.713 10.598 1.712 3.205 4.728 6.098 8.78 7.572",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.193 2930.394c3.551 2.222 7.917 2.817 11.815 1.693 3.7-1.183 7.153-4.06 9.194-8.163 2.193-3.968 1.876-8.62.441-12.298-1.51-3.73-4.516-6.694-8.516-8.154a16.962 16.962 0 0 0-11.712.036c-3.653 1.28-6.188 3.825-8.04 7.053-1.721 3.313-1.651 7.098-.377 10.752a16.425 16.425 0 0 0 7.195 9.081",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.31 2954.38c3.118 2.872 7.293 4.282 11.267 3.894 3.894-.5 7.823-2.614 10.608-6.193 2.93-3.535 3.519-8.134 2.816-12.072-.813-3.965-3.19-7.4-6.808-9.615-3.635-2.153-7.889-2.8-11.609-2.208-3.763.627-6.737 2.637-9.157 5.443-2.328 2.926-3.062 6.646-2.485 10.467.512 3.696 2.19 7.418 5.367 10.283",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.258 2974.62c2.502 3.341 6.363 5.55 10.319 5.878 3.941.259 8.183-1.094 11.597-4.087 3.553-2.868 4.985-7.297 5.025-11.294-.06-4.017-1.697-7.873-4.89-10.738-3.142-2.839-7.133-4.24-10.9-4.346-3.823-.151-7.095 1.278-10.064 3.59-2.79 2.402-4.197 5.964-4.357 9.793-.185 3.792.69 7.72 3.27 11.204",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.79 2990.21c1.833 3.765 5.1 6.702 8.976 7.743 3.816 1.057 8.282.505 12.185-1.807 4.055-2.107 6.207-6.272 7.021-10.091.778-3.976-.176-8.078-2.714-11.435-2.555-3.436-6.275-5.59-9.931-6.372-3.693-.91-7.23-.106-10.496 1.594-3.228 1.867-5.341 5.042-6.173 8.773-.898 3.738-.798 7.72 1.132 11.595",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.777 3000.694c1.072 4.088 3.823 7.624 7.335 9.297 3.546 1.77 7.98 2.076 12.361.588 4.345-1.313 7.308-4.992 8.774-8.63 1.542-3.737 1.446-7.91-.457-11.739-1.899-3.848-5.06-6.605-8.532-8.122-3.513-1.633-7.058-1.431-10.666-.419-3.511 1.173-6.12 3.909-7.706 7.419-1.558 3.547-2.225 7.421-1.11 11.606",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.259 3005.647c.486 8.738 8.29 14.646 17.46 13.476 9.033-1.698 14.417-10.315 12.058-18.43-2.367-8.283-10.001-13.314-17.19-12.036-7.235.86-12.72 8.764-12.328 16.99",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.365 3004.938c-1.146 8.461 5.362 15.906 14.58 16.542 9.202-.148 16.09-7.327 15.314-15.833-.73-8.48-7.246-15.231-14.506-15.012-7.374-.623-14.233 5.88-15.388 14.302",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.163 2998.541c-2.778 8.004 2.165 16.795 11.176 18.951 9.04 1.61 17.188-3.895 18.026-12.555.832-8.286-4.296-16.383-11.422-17.606-7.092-1.72-15.018 3.037-17.78 11.21",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.714 2986.635c-4.202 7.303-1.152 17.012 7.341 20.793 8.551 3.403 17.554-.555 20.108-8.887 2.43-7.966-1.058-16.813-7.894-19.476-6.697-2.969-15.214.102-19.555 7.57",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.058 2969.782c-2.758 3.204-3.88 7.277-3.308 11.259.613 3.907 2.58 8.11 6.475 10.466 3.814 2.496 8.311 3.258 12.118 2.375 3.846-.767 7.353-3.559 9.37-7.247 2.136-3.81 2.381-7.69 1.68-11.576-.665-3.72-2.603-7.052-5.726-9.008-6.003-4.15-15.009-2.808-20.609 3.73",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.015 2948.505c-3.336 2.693-5.18 6.442-5.375 10.456-.15 3.899 1.003 8.502 4.408 11.544 3.274 3.147 7.432 4.72 11.404 4.654 3.936-.082 7.917-2.18 10.606-5.378 2.758-3.314 3.784-7.167 3.857-11.047-.002-3.781-1.217-7.382-3.946-9.964-2.758-2.469-5.962-4.104-9.858-4.087-3.765-.037-7.804 1.123-11.096 3.822",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.357 2923.698c-3.722 1.99-6.283 5.314-7.232 9.228-.886 3.807-.635 8.537 2.139 12.15 2.627 3.7 6.475 6.052 10.345 6.7 3.865.69 8.165-.608 11.406-3.271 3.366-2.747 5.11-6.274 5.888-10.07.742-3.79.226-7.487-1.912-10.515-2.43-2.967-5.176-5.155-8.957-5.894a16.772 16.772 0 0 0-11.677 1.672",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.784 2896.13c-4.074 1.243-7.205 4.015-8.867 7.654-1.671 3.6-2.271 8.301-.222 12.375 1.855 4.155 5.17 7.207 8.835 8.583 3.719 1.339 8.164.91 11.827-1.044 3.822-2.082 6.23-5.228 7.683-8.764 1.437-3.615 1.622-7.367.123-10.736-1.78-3.348-4.07-6.008-7.61-7.477-3.448-1.509-7.7-1.855-11.769-.592",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.691 2866.804c-4.2.533-7.826 2.654-10.217 5.879-2.35 3.24-3.761 7.687-2.533 12.081 1.012 4.497 3.637 8.077 7.035 10.144 3.446 2.002 7.777 2.46 11.808 1.221 4.117-1.288 7.134-3.987 9.131-7.14 2.16-3.25 3.118-6.904 2.223-10.539-.996-3.553-2.94-6.683-6.048-8.752-3.107-2.109-7.163-3.331-11.399-2.894m309.938 7.757-.779-.187-.77-.179-.74-.272-.695-.257-.707-.396-.719-.365-.636-.435-.622-.526-.596-.459-.562-.553-.555-.594-.515-.578-.518-.618-.494-.68-.426-.679-.26-.395-.14-.206-.036-.077-.027-.037-.002-.02h-.02l-.003-.03c.322.137.322.137.473.19l-.65-.573-.03-.01-.053-.014-.043-.036-.084-.05-.155-.135-.416-.176-.663-.462-.759-.481-.688-.44-.61-.587-.593-.52-.57-.582-.512-.598-.52-.658-.395-.642-.439-.687-.33-.698-.34-.748-.19-.704-.225-.73-.158-.818-.083-.765-.086-.796-.035-.8.085-.744.074-.772.185-.764.173-.763.232-.76.29-.775.28-.674.4-.737.395-.717.467-.694.468-.684.569-.635.528-.64.517-.629.667-.595 1.324-1.128.701-.569.694-.527.77-.506.814-.4.824-.48.842-.453.87-.365.877-.347 1.779-.594.851-.262.894-.238.972-.165 1.026-.18 1.022-.141 1.003-.129.938-.05.973.015.985-.01.939.07.907.073.91.164.896.155.898.235.904.224.811.305.812.315.796.316.51.68.443.726.461.775.416.76.37.885.305.822.35.878.267.876.264.917.212.913.201.984.15.95.13 1.001.063.98.035 1.011.019 1.044-.12 1.25-.143 1.162-.194 1.188-.22 1.13-.253 1.114-.256 1.123-.33 1.092-.408 1.03-.313 1.03-.464.975-.398.948-.475.876-.541.883-.47.855-.558.764-.583.707-.584.717-.711.65-.672.575-.73.521-.698.528-.73.441-.712.429-.798.287-.716.319-.76.252-.859.153-.735.18-.822.028-.778.024-.756-.049-.795-.075",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m591.024 2850.012-.176.773-.228.728-.277.785-.297.706-.377.694-.4.667-.447.621-.487.626-.545.592-.603.568-.557.512-.632.521-.649.503-.692.466-.705.418-.411.196-.207.052-.099.101.003.03-.05.01-.017.032-.618.459c.233-.065.19-.061.368-.08l-.049-.015.006.06-.046.035-.004.071-.13.175-.275.331-.555.684-.488.616-.544.601-.554.553-.536.53-.63.48-.629.521-.665.424-.675.374-.623.34-.81.318-.686.275-.778.184-.763.173-.796.086-.796.086-.789-.026h-.746l-.822-.112-.741-.132-.788-.247-.742-.282-.784-.317-.683-.35-.749-.391-.691-.469-.712-.517-.697-.528-.613-.658-.368-.312-.223-.348-.59-.67-.538-.768-.532-.767-.443-.837-.425-.88-.473-.894-.386-.914-.422-1-.33-.981-.267-1.098-.274-1.006-.265-1.108-.16-1.09-.17-1.138-.143-1.14-.058-1.151-.06-1.18.035-1.02.09-.955.104-.937.209-.968.14-.86.232-.94.282-.885.28-.866.37-.834.354-.823.394-.726.384-.806.446-.712.419-.739.56-.674.503-.658.787-.356.774-.325.822-.21.82-.299.855-.193.88-.195.908-.138.835-.09.94-.101.925.02.889-.034.936.06.951.068.908.143 1.033.15.873.228 1.02.212.933.332.786.257.964.379.84.352.843.361.829.424.823.464.741.494.786.519.7.517.721.526.612.608.633.616.566.623.609.618.508.599.484.732.49.662.39.692.386.733.337.728.314.72.222.75.209.773.21.752.113.742.043.8-.003.775-.028.807-.055.79-.152.751",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M865.967 2860.537c1.536-65.301-59.025-119.571-135.227-121.322-76.173-1.785-139.163 49.685-140.664 114.972-1.498 65.217 59.057 119.498 135.26 121.238 76.175 1.754 139.165-49.716 140.631-114.888",
    style: {
      fill: "#f6c4a0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.222 2763.687c27.493-.482 39.068 20.477 39.459 39.532l-77.239 1.355c-.39-19.055 11.5-40.426 37.78-40.887",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.607373
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.772 2871.202c.191-7.694-5.966-14.121-13.687-14.315-7.713-.184-14.087 5.965-14.278 13.67-.185 7.714 5.92 14.117 13.645 14.28 7.684.207 14.139-5.95 14.32-13.635",
    style: {
      fill: "#754c29",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.004 2874.376c.102-3.2-2.426-5.874-5.586-5.925-3.245-.103-5.924 2.45-6 5.656-.063 3.195 2.465 5.84 5.715 5.911 3.201.067 5.813-2.417 5.87-5.642",
    style: {
      fill: "#f1f2f2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.983 2873.179a14.02 14.02 0 0 0-13.668-14.348c-7.683-.167-14.138 5.95-14.318 13.684-.165 7.692 6.009 14.117 13.668 14.287 7.718.154 14.102-5.966 14.318-13.623",
    style: {
      fill: "#754c29",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.862 2876.012c.058-3.174 2.721-5.735 5.892-5.664a5.81 5.81 0 0 1 5.702 5.913 5.783 5.783 0 0 1-5.99 5.654c-3.15-.053-5.684-2.706-5.604-5.903",
    style: {
      fill: "#f1f2f2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.824 2829.045c.252-10.407-8.056-19.026-18.463-19.282-10.5-.246-19.068 8.01-19.291 18.404-.242 10.436 7.961 19.097 18.442 19.345 10.411.255 19.067-8.051 19.312-18.467m223.622 5.115c.225-10.413 8.888-18.65 19.263-18.44 10.458.29 18.744 8.921 18.49 19.329-.241 10.435-8.906 18.692-19.36 18.472-10.393-.218-18.642-8.913-18.393-19.36",
    style: {
      fill: "#f6c4a0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.627 2898.136c-13.052-.293-24.267-5.118-29.755-11.819 0 0 13.913 8.055 29.866 8.437 16.827.399 30.309-7.06 30.309-7.06-5.805 6.47-17.165 10.722-30.42 10.442m90.783 2.099c-13.061-.311-24.286-5.126-29.816-11.841 0 0 13.898 8.056 29.895 8.413 16.813.41 30.307-7.03 30.307-7.03-5.854 6.445-17.212 10.748-30.386 10.458",
    style: {
      fill: "#754c29",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.311 2910.102c-20.859-.477-37.387-17.815-36.939-38.693.498-20.813 17.81-37.385 38.668-36.908 20.863.516 37.39 17.804 36.914 38.635-.468 20.88-17.83 37.457-38.643 36.966zm1.828-81.435c-24.03-.548-44.027 18.556-44.6 42.606-.523 24.085 18.557 44.065 42.612 44.64 24.057.544 44.085-18.564 44.603-42.648.557-24.058-18.535-44.047-42.615-44.598m102.971 83.843c-20.85-.507-37.443-17.828-36.956-38.71.47-20.79 17.853-37.38 38.716-36.874 20.791.474 37.36 17.818 36.908 38.596-.465 20.9-17.83 37.457-38.667 36.989zm1.892-81.432c-24.063-.553-44.13 18.558-44.657 42.593-.568 24.1 18.582 44.072 42.663 44.624 24.034.557 44.032-18.537 44.575-42.645.559-24.008-18.556-44.054-42.581-44.571",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m738.037 2868.94-21.093-.502-.142 5.86 21.086.472.15-5.83m85.953 4.934-4.634 3.557 29.935 39.207 4.6-3.534-29.9-39.23",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m633.797 2869.49-31.78 39.338 3.868 3.356 31.735-39.296-3.823-3.398",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.885147
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.706 2962.263c.226-9.308-7.174-17.009-16.471-17.203-9.306-.204-17.03 7.126-17.224 16.43-.231 9.3 7.15 16.972 16.457 17.196 9.268.207 16.988-7.123 17.238-16.423",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.473 2963.748c.204-9.255-7.13-17.004-16.441-17.187-9.343-.22-17.055 7.18-17.26 16.435-.223 9.328 7.15 17.012 16.466 17.224 9.296.235 17.032-7.137 17.235-16.472m-56.509-41.068c.19-9.315-7.19-17.048-16.507-17.28-9.314-.203-17.027 7.186-17.225 16.491-.212 9.296 7.12 16.985 16.42 17.219 9.333.2 17.074-7.192 17.312-16.43",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.558 2942.856c.201-9.285-7.157-17.04-16.446-17.236-9.364-.227-17.007 7.155-17.239 16.443-.2 9.305 7.117 17.066 16.432 17.288 9.314.203 17.048-7.179 17.253-16.495",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.612 2954.366c.196-9.335-7.185-17.048-16.5-17.23-9.29-.226-16.982 7.131-17.185 16.436-.22 9.297 7.13 17.014 16.424 17.25 9.291.174 17.054-7.16 17.261-16.456m62.583 19.774c.203-9.305-7.128-16.983-16.416-17.209-9.337-.19-17.088 7.133-17.284 16.428-.227 9.338 7.137 17.073 16.47 17.284 9.318.202 17.01-7.135 17.23-16.502",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.084 2969.633c.232-9.942-7.665-18.253-17.635-18.445-10.01-.279-18.275 7.703-18.488 17.603-.22 9.991 7.648 18.286 17.648 18.505 9.985.23 18.252-7.701 18.475-17.662",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.078 2954.165c.153-7.318-5.6-13.387-12.944-13.54-7.323-.176-13.371 5.606-13.547 12.977-.162 7.239 5.623 13.334 12.954 13.519 7.317.157 13.387-5.638 13.537-12.956",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.657 2962.625c.221-9.317 7.895-16.672 17.21-16.46 9.29.205 16.693 7.906 16.492 17.221-.205 9.296-7.97 16.64-17.255 16.445a16.827 16.827 0 0 1-16.447-17.206",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.726 2965.08c.209-9.245 7.973-16.63 17.247-16.393 9.31.173 16.694 7.906 16.511 17.179-.227 9.338-8.014 16.695-17.31 16.48-9.24-.22-16.67-7.908-16.448-17.266m58.368-38.428c.208-9.296 7.94-16.718 17.253-16.495 9.294.205 16.676 7.928 16.467 17.244-.195 9.264-7.94 16.667-17.23 16.442-9.313-.183-16.694-7.936-16.49-17.191",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.587 2946.04c.204-9.295 7.967-16.67 17.208-16.47 9.29.236 16.698 7.946 16.474 17.264-.228 9.298-7.921 16.645-17.212 16.44-9.296-.225-16.698-7.946-16.47-17.234",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.022 2956.573c.201-9.315 7.947-16.698 17.215-16.48 9.286.195 16.676 7.957 16.469 17.263-.207 9.266-7.95 16.638-17.265 16.416-9.235-.191-16.616-7.915-16.42-17.2",
    style: {
      fill: "#8f402f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724.824 2351.25h-119.39l-1.379 296.85 120.769 28.71v-325.56",
    style: {
      fill: "#e9e9e9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m931.784 2481.883 18.45-54.58-74.349-96.06-20.738 14.57 76.637 136.07",
    style: {
      fill: "#d19771",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826.073 2301.303s11.406 10.47 8.7 13.55c-4.325 5.02-18.829-16.58-24.966-7.57-5.004 7.28 11.254 10.07 19.653 22.77 16.402 24.86 29.144 21.68 29.144 21.68l20.641-13.52s-27.48-50.64-30.96-54.04c-2.892-2.81-15.52-15.82-31.614-25.02-.665-.39-8.11 16.17-8.438 24.4-.469 11.85 17.84 17.75 17.84 17.75",
    style: {
      fill: "#f6c4a0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.946 2684.333s117.846-26.88 139.685-59.23c23.317-34.57 85.282-124.31 89.774-161.38 2.23-18.87-41.28-79.41-83.734-132.48l-31.524 34.79 45.461 101.94s-66.305 87.95-79.449 107.41l-92.285 44.43-110.8 30.33",
    style: {
      fill: "#e9e9e9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.577 2350.833h119.39l1.38 296.85-120.77 28.71v-325.56",
    style: {
      fill: "#e9e9e9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.391 2351.25h-10.953v322.77h10.953v-322.77",
    style: {
      fill: "#d8d1d1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724.535 2644.47c0-2.03-1.597-3.67-3.594-3.67a3.665 3.665 0 0 0-3.66 3.67c0 2.01 1.641 3.63 3.66 3.63 1.997 0 3.594-1.62 3.594-3.63m0-61.76c0-2.03-1.597-3.65-3.594-3.65a3.647 3.647 0 0 0-3.66 3.65c0 1.97 1.641 3.59 3.66 3.59a3.592 3.592 0 0 0 3.594-3.59m0-61.78c0-1.99-1.597-3.61-3.594-3.61-2.019 0-3.66 1.62-3.66 3.61 0 2.03 1.641 3.65 3.66 3.65 1.997 0 3.594-1.62 3.594-3.65m0-61.72c0-2.03-1.597-3.65-3.594-3.65a3.647 3.647 0 0 0-3.66 3.65c0 2 1.641 3.6 3.66 3.6 1.997 0 3.594-1.6 3.594-3.6m0-61.75c0-2.01-1.597-3.67-3.594-3.67-2.019 0-3.66 1.66-3.66 3.67 0 1.99 1.641 3.59 3.66 3.59a3.58 3.58 0 0 0 3.594-3.59",
    style: {
      fill: "#f14950",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#debb7e",
    d: "M58.01 54.672H46.675c-.828 0-1.585-.556-1.657-1.228L43.492 39.12c-.106-1.002.63-1.81 1.726-1.81h14.25c1.04 0 1.825.861 1.719 1.863l-1.52 14.271c-.072.672-.785 1.228-1.657 1.228Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f0d5a8",
    d: "M59.467 37.31h-14.25c-1.096 0-1.831.808-1.725 1.81l.217 2.035c-.102-.954.618-1.723 1.687-1.723h13.893c1.015 0 1.783.82 1.681 1.772l.217-2.031c.112-1.055-.624-1.864-1.72-1.864Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.34 44.5H13.66c-1.512 0-2.893-1.283-3.024-2.835L7.852 8.583C7.657 6.268 9 4.4 11 4.4h26c1.9 0 3.332 1.991 3.138 4.303l-2.774 32.962c-.131 1.552-1.432 2.835-3.023 2.835Z",
    className: "st3",
    style: {
      fill: "none",
      stroke: "#45413c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    transform: "matrix(.54806 0 0 .43298 39.189 35.404)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.328 2301.72s-11.406 10.47-8.699 13.55c4.324 5.02 18.828-16.58 24.965-7.57 5.004 7.28-11.254 10.07-19.653 22.77-16.402 24.86-29.144 21.68-29.144 21.68l-20.641-13.52s27.481-50.64 30.961-54.04c2.891-2.81 15.52-15.82 31.613-25.02.665-.39 8.11 16.17 8.438 24.4.469 11.85-17.84 17.75-17.84 17.75",
    style: {
      fill: "#f6c4a0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.06646 0 0 -.06646 4.538 200.797)"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpert2);
export default __webpack_public_path__ + "static/media/expert2.fffee8aa435dd0988f3c7ddfba1f4f38.svg";
export { ForwardRef as ReactComponent };